import Bluebird from 'bluebird';
import { apiCall } from './api';
import { getBillingAccountId } from './app-storage';

export interface IUserConfig {
    useUTC: boolean;
    referenceIsRequired: boolean;
    accountName?: string;
}

const cache = new Map<number | null, IUserConfig>();

const FALLBACK_CONFIG: IUserConfig = { useUTC: false, referenceIsRequired: false };

export default async function fetchUserConfig(): Bluebird<IUserConfig> {
    const accountId = getBillingAccountId();

    const cached = cache.get(accountId);
    if (cached) {
        return cached;
    }

    const path = accountId !== null ? `config/${accountId}` : 'config';

    try {
        const {
            data: {
                agent: {
                    primary_time_zone_utc: useUTC,
                    referenceIsRequired
                },
                account
            }
        } = await apiCall<API.ConfigResponse>('GET', path);

        const result: IUserConfig = { useUTC, referenceIsRequired, accountName: account?.name };
        cache.set(accountId, result);
        return result;
    } catch (error) {
        if (accountId === null) {
            return FALLBACK_CONFIG;
        }
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/user-config.ts